import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=0af3977a&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"
import style0 from "./notification.vue?vue&type=style&index=0&id=0af3977a&prod&lang=scss"
import style1 from "./notification.vue?vue&type=style&index=1&id=0af3977a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af3977a",
  null
  
)

export default component.exports